import {Color} from '@benchling/nucleus-ui';
import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {TargetItemInfo} from 'llm/chat-library/getTargetItem';
import BenchChip from 'ui-library/chips/BenchChip';
import {ChipSize} from 'ui-library/chips/Chip';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

interface TargetItemChipProps {
  targetItem: TargetItemInfo;
}

/**
 * Displays a chip indicator for the target item of a chat. For example, in Compose over Entries,
 * this shows a chip for the entry being edited.
 */
export default function TargetItemChip({targetItem}: TargetItemChipProps): JSX.Element {
  return (
    <div className={css(styles.targetItemOuter)}>
      <div className={css(styles.targetItemGroup)}>
        <BenchlingIcon className={css(styles.editIcon)} icon="pen" />
        <BenchChip className={css(styles.chip)} size={ChipSize.MINI} id={targetItem.itemId} />
      </div>
    </div>
  );
}

const styles = StyleSheet.create({
  targetItemOuter: {
    padding: '8px 12px 0',
  },
  targetItemGroup: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    border: `1px solid ${Color.GRAY_400}`,
    borderRadius: 4,
    padding: '4px 8px',
    overflow: 'hidden',
  },
  editIcon: {
    color: Color.GRAY_400,
    fontSize: '14px',
    flexShrink: 0,
  },
  chip: {
    fontSize: '12px',
    whiteSpace: 'nowrap',
    marginRight: 0,
    minWidth: 0,
  },
});
